import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import VehicleFallbackSrc from 'assets/images/vehicle-none.png';

import './TableCellContent.styles.scss';

type VehicleTableCellsProps = {
  className?: string;
  val: any;
  config?: Record<string, any>;
};

export const VehicleImageCell: React.FC<VehicleTableCellsProps> = ({ val }) => {
  const src = val[0]?.url;
  return (
    <img
      className="fm-vehicle-img-table"
      src={src || VehicleFallbackSrc}
      alt="fm-logo-img"
    />
  );
};

export const LinkToVehicles: React.FC<VehicleTableCellsProps> = ({
  className,
  config,
}) => {
  const {
    instance: { _id: fleetId },
  } = config;

  const classes = classNames('fleet-cell-link', className);

  return (
    <div className={classes}>
      <LinkComponent
        link="vehicles"
        text="vehicles"
        className={classes}
        fleetId={fleetId}
      />
    </div>
  );
};

export const LinkToManagers: React.FC<VehicleTableCellsProps> = ({
  className,
  config,
}) => {
  const {
    instance: { _id: fleetId },
  } = config;

  const classes = classNames('fleet-cell-link', className);

  return (
    <div className={classes}>
      <LinkComponent
        link="users/managers"
        text="managers"
        className={classes}
        fleetId={fleetId}
      />
    </div>
  );
};

type LinkCompProp = {
  link: string;
  text: string;
  fleetId: string;
  className: string;
};

const LinkComponent: React.FC<LinkCompProp> = ({
  link,
  text,
  fleetId,
  className,
}) => {
  const { t } = useTranslation();

  const classes = classNames('fleet-cell-link', className);

  const urlSP = new URLSearchParams(window.location.search);
  urlSP.set('filter', JSON.stringify({ fleetId }));

  return (
    <div className={classes}>
      <Link
        to={{
          pathname: `/dash/${link}`,
          search: `?${urlSP.toString()}`,
        }}
      >
        {t(text)}
      </Link>
    </div>
  );
};
